import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { inject, observer } from 'mobx-react';
import isEmpty from 'lodash/isEmpty';

import Scene from '../Scene';
import Container from '../../components/Container';
import Indent from '../../components/Indent';
import { crossScreenPaddingTop, toVw, toVwMobile, toVwTablet } from '../../utils/styles';
import Title from '../../components/Title/';
import Subtitle from '../../components/Title/components/Subtitle';
import Vacancies from './components/Vacancies';
import mq from '@/utils/media-queries';
import Media from '../../components/Media';
import PreviewNextPage from '../../components/PreviewNextPage';
import AnimationOnPageLoadItem from '../../components/AnimationOnPageLoadItem';

const JobsScene = styled(Scene)`
  ${crossScreenPaddingTop(572)};
`;

const JobsContainer = styled(Container)`
  padding-bottom: ${toVw(277)};

  ${mq.tablet(css`
    padding-bottom: ${toVwTablet(276)};
  `)};

  ${mq.mobile(css`
    padding-bottom: ${toVwMobile(267)};
  `)};
`;

const TITLE_MARGIN_BOTTOM = 252;

const StyledTitle = styled(Title)`
  margin-bottom: ${toVw(TITLE_MARGIN_BOTTOM)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(TITLE_MARGIN_BOTTOM)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(267)};
  `)};
`;

const SUBTITLE_MARGIN_BOTTOM = 121;

const StyledSubtitle = styled(Subtitle)`
  margin-bottom: ${toVw(SUBTITLE_MARGIN_BOTTOM)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(SUBTITLE_MARGIN_BOTTOM)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(139)};
  `)};
`;

const PHOTO_MARGIN_BOTTOM = 180;

const Photo = styled(Media)`
  margin-bottom: ${toVw(PHOTO_MARGIN_BOTTOM)};

  ${mq.tablet(css`
    margin-bottom: ${toVwTablet(PHOTO_MARGIN_BOTTOM)};
  `)};

  ${mq.mobile(css`
    margin-bottom: ${toVwMobile(PHOTO_MARGIN_BOTTOM)};
  `)};
`;

class Jobs extends React.Component {
  static propTypes = {
    jobsStore: PropTypes.object.isRequired,
  };

  componentDidMount() {
    this.props.jobsStore.load();
  }

  render() {
    const { jobsStore, ...rest } = this.props;

    const { photo, nextPreview } = jobsStore.toJSON();
    const vacancies = jobsStore.vacanciesByCategory;

    return (
      <JobsScene dark={true} {...rest}>
        <JobsContainer>
          <Indent>
            <AnimationOnPageLoadItem>
              <React.Fragment>
                <StyledTitle>Join us</StyledTitle>
                <StyledSubtitle>
                  <span>Today we have</span>
                  <br />
                  <span data-test="vacancy-count">{jobsStore.vacancies.length}</span> openings
                </StyledSubtitle>
              </React.Fragment>
            </AnimationOnPageLoadItem>
          </Indent>
          <AnimationOnPageLoadItem>{!isEmpty(photo) && <Photo {...photo} />}</AnimationOnPageLoadItem>
          <Indent>
            <Vacancies items={vacancies} />
          </Indent>
        </JobsContainer>
        {nextPreview && <PreviewNextPage {...nextPreview} />}
      </JobsScene>
    );
  }
}

export default inject(stores => ({ jobsStore: stores.store.jobsStore }))(observer(Jobs));



// WEBPACK FOOTER //
// ./src/scenes/Jobs/index.js